import styled from "styled-components";
import { darken } from 'polished';

const SBlueButton = styled.button`
    color: white;
    border: none;
    border-radius: 6px;
    background-color: #2E5496;
    padding: 8px 24px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.3px;
    transition: background-color 0.22s ease, transform 0.18s ease, box-shadow 0.22s ease;
    box-shadow: 0 2px 8px rgba(46,84,150,0.25);

    &:hover {
        background-color: ${darken(0.08, '#2E5496')};
        transform: translateY(-1px);
        box-shadow: 0 4px 16px rgba(46,84,150,0.35);
    }

    &:active {
        background-color: ${darken(0.15, '#2E5496')};
        transform: translateY(0);
    }

    &:focus {
        outline: none;
    }
`;

export default SBlueButton;
